/* src/app/pages/previous-analysis/show-table/show-table.component.scss */
table {
  width: 100%;
}
/*# sourceMappingURL=show-table.component.css.map */
